import { useEffect, useState } from "react";
import { FaArrowUp } from "react-icons/fa";

function ScrollTopButton() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const path = document.querySelector(".progress-circle path");
    const pathLength = path.getTotalLength();

    // Set up stroke style properly
    path.style.strokeDasharray = `${pathLength} ${pathLength}`;
    path.style.strokeDashoffset = pathLength;

    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.body.scrollHeight - window.innerHeight;
      const progress = pathLength - (scrollTop * pathLength) / docHeight;
      path.style.strokeDashoffset = progress;

      setIsVisible(scrollTop > 200);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      <style>
        {`
          .scroll-top {
            position: fixed;
            right: 20px;
            bottom: 20px;
            height: 40px;
            width: 40px;
            cursor: pointer;
            z-index: 10000;
            opacity: 1;
            visibility: hidden;
            transform: translateY(45px);
            transition: all 300ms linear;
          }

          .scroll-top svg {
             background: #F22A2B; /* Red background */
          }

          .scroll-top .progress-circle path {
            fill: none;
            stroke: var(--theme-color);
            stroke-width: 12px;
            transition: all 400ms linear;
          }

          .scroll-top.show {
            opacity: 1;
            visibility: visible;
            transform: translateY(0);
          }
              .scroll-icon {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            color: #ffffff; /* White arrow */
            font-size: 15px;
            z-index: 2;
          }
        `}
      </style>

      <div
        className={`scroll-top ${isVisible ? "show" : ""}`}
        onClick={scrollToTop}
      >
        <svg
          className="progress-circle"
          width="100%"
          height="100%"
          viewBox="-1 -1 102 102"
        >
          <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
        </svg>
        <FaArrowUp className="scroll-icon" />
      </div>
    </>
  );
}

export default ScrollTopButton;
